import React from 'react';
import { Progress } from '@/components/ui/progress';
import { cn } from '@/lib/utils';

export const ConvenienceBar = ({ value, showLabel = true, size = 'md' }) => {
  const percentage = Math.round(value * 100);
  
  const getColorClass = () => {
    if (percentage >= 70) return 'bg-green-500';
    if (percentage >= 40) return 'bg-amber-500';
    return 'bg-red-500';
  };

  const sizeClasses = {
    sm: 'h-1.5',
    md: 'h-2',
    lg: 'h-3'
  };

  return (
    <div className="flex items-center gap-2">
      <div className={cn('flex-1 bg-gray-700 rounded-full overflow-hidden', sizeClasses[size])}>
        <div 
          className={cn('h-full rounded-full', getColorClass())}
          style={{ width: `${percentage}%` }}
        />
      </div>
      {showLabel && (
        <span className="text-xs text-gray-400 w-10 text-right">{percentage}%</span>
      )}
    </div>
  );
};

export default ConvenienceBar;
